import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfimationModalComponent } from '../confimation-modal/confimation-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private _http: HttpClient,
    public dialog: MatDialog,
  ) { 
  }

  private organizationUpdate = new BehaviorSubject(null);
  organizationDataUpdate = this.organizationUpdate.asObservable();

  updateHeader(data) {
    this.organizationUpdate.next(data);
  }

  getOrganization(orgCode) {
    return this._http.get(environment.url + "/organization/details/" + orgCode);
  }

  updateOrganization(requestData) {
    return this._http.put(environment.url + "/organization", requestData);
  }

  updateUser(requestData) {
    return this._http.put(environment.url + "/updateUser", requestData);
  }

  updateTheme(requestData) {
    return this._http.put(`${environment.url}/user/organization/theme`, requestData)
  }
}
